import { Camera, Object3D, Raycaster, Vector2 } from "three";

export type ArtworkSelection = {
  artworkId: string;
  title: string;
  object: Object3D;
  distance: number;
};

export function selectArtwork(
  raycaster: Raycaster,
  camera: Camera,
  scene: Object3D,
  pointer: Vector2 = new Vector2(0, 0),
  maxDistance = 6,
): ArtworkSelection | null {
  raycaster.setFromCamera(pointer, camera);
  raycaster.far = maxDistance;
  const intersections = raycaster.intersectObject(scene, true);
  for (const intersection of intersections) {
    if (intersection.distance > maxDistance) return null;
    const interactive = interactiveAncestor(intersection.object);
    if (interactive === null) return null;
    return {
      artworkId: String(interactive.userData.artwork_id),
      title: String(interactive.userData.title ?? "Obra"),
      object: interactive,
      distance: intersection.distance,
    };
  }
  return null;
}

function interactiveAncestor(object: Object3D): Object3D | null {
  let current: Object3D | null = object;
  while (current !== null) {
    if (current.userData.interactive === true && typeof current.userData.artwork_id === "string") {
      return current.userData.interaction_kind === "artwork_label" ? current : null;
    }
    current = current.parent;
  }
  return null;
}
